// extracted by mini-css-extract-plugin
module.exports = {"borders":"aboutus-module--borders--2UHQ6"};